import request from '../utils/request'

export function list(object) {
    return request.post('/sys-notice/list', object)
}

export function queryById(id) {
    return request.get('/sys-notice/'+id)
}

export function getNoticeTypeAll() {
    return request.post('/sys-notice/getNoticeTypeAll')
}
